import api from '../api/api-list'

const state = {
	experienceField: '',
	custom_ids: {},
	custom_id: null,
	works: [],
	orgs: [],
	edus: [],
	opus: [],
	personal_summary: [],
	project_experience: [],
	reasearch_experience: [],
	honor: [],
	skill_list: [],
	custom: [],
	extras: [],
	experienceEnter: false // 是否进入过experience
}

const getters = {
	// 当前dialog中可供选择的经历
	currentExperience: state => state[state.experienceField],
	// 当前选中的extras
	pitchExtras: state => {
		let others = {}
		for (let key in state.extras) {
			others[key] = state.extras[key].filter(item => item.checked)[0]
		}
		return others
	},
	// 当前所在编辑的经历的所属模块的自定义模块的id
	currentCustomId: state => state.experienceField === 'custom' ? state.custom_id : state.custom_ids[`${ state.experienceField }_id`]
}

const actions = {
	// edu，work，org, opu
	getExperience: async function ({ commit }, { payload, template, moduleName, apiMethod, defaultId }) {
		try {
			let res = await api.cv[`${ apiMethod }`](payload)
			if (res.code === 1000) {
				res.data[`${ moduleName }`].forEach((item, index) => {
					if (template && template.includes(moduleName)) {
						item.checked = index < 2
					} else {
						item.checked = false
					}
				})
				commit('changeExperience', { info: res.data[moduleName], moduleName })
			}
		} catch (e) {
			console.log(e)
		}
	},
	getCustomExperienceById: async function ({ commit }, { id }) {
		try {
			let res = await api.cv.getCustomInfoById(id)
			console.log(res, '--')
		} catch (e) {
			console.log(e)
		}
	},
	// 自定义模块
	getCustomExperience: async function ({ commit }, { payload, template }) {
		try {
			let res = await api.cv.getCustomExperience(payload)
			if (res.code === 1000) {
				let fields = [ 'personal_summary', 'project_experience', 'reasearch_experience', 'honor', 'skill_list', 'custom' ]
				let ids = {}
				let { custom_sections } = res.data
				commit('changeExperience', { info: [], moduleName: 'custom', refresh: true })
				custom_sections.forEach(item => {
					if (item.category) {
						ids[`${ item.category }_id`] = item.id
						item.infos.forEach((val, index) => {
							if (template && template.includes(item.category)) {
								val.checked = item.category === 'personal_summary' || item.category === 'skill_list' ? index < 1 : index < 2
							} else {
								val.checked = false
							}
						})
						commit('changeExperience', { info: item.infos, moduleName: item.category })
					} else {
						ids[`${ item.id }_id`] = item.id
						commit('changeExperience', { info: item, moduleName: 'custom', })
					}
				})
				commit('changeCustomIds', ids)
				// let customExperience = {}
				// fields.forEach(item => {
				// 	if (item === 'custom') {
				// 		customExperience[`custom`] = res.data.custom_sections.filter(i => !i.category)
				// 	} else {
				// 		customExperience[item] = res.data.custom_sections.filter(i => i.category === item)
				// 	}
				// })
				// for (let key in customExperience) {
				// 	customExperience[key].forEach((item, index) => {
				// 		if (template && template.includes(key)) {
				// 			item.checked = key === 'personal_summary' || key === 'skill_list' ? index < 1 : index < 2
				// 		} else {
				// 			item.checked = false
				// 		}
				// 	})
				// 	commit('changeExperience', { info: customExperience[key], moduleName: key })
				// }
			}
		} catch (e) {
			console.log(e)
		}
	},
	// extras接口
	getExtrasExperience: async function ({ commit }, { payload, template, abc }) {
		try {
			let res = await api.cv.getExtrasExperience(payload)
			if (res.code === 1000) {
				let extras = res.data.others
				for (let key in extras) {
					extras[key].forEach((item, index) => {
						if (template && template.includes('extras')) {
							item.checked = index < 1
						} else {
							item.checked = false
						}
					})
				}
				commit('changeExperience', { info: extras, moduleName: 'extras' })
			}
		} catch (e) {
			console.log(e)
		}
	}
}

const mutations = {
	changeExperience (state, { info, moduleName, refresh }) {
		if (moduleName === 'custom') {
			state.custom = refresh ? [] : [ ...state.custom, info ]
		} else {
			state[moduleName] = info
		}
	},
	changeCustomId (state, id) {
		state.custom_id = id
	},
	changeExperienceField (state, field) {
		state.experienceField = field
	},
	changeCustomIds (state, ids) {
		state.custom_ids = ids
	},
	changeExperienceEnter (state, value) {
		state.experienceEnter = value
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
